'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _UNITS_OF_MEASURE;function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var UNIT_OF_MEASURE_TYPES = exports.UNIT_OF_MEASURE_TYPES = {
  DIMENSION: 'dimension',
  WEIGHT: 'weight',
  AREA: 'area',
  VOLUME: 'volume',
  COUNT: 'count' };


var UNITS_OF_MEASURE = exports.UNITS_OF_MEASURE = (_UNITS_OF_MEASURE = {}, _defineProperty(_UNITS_OF_MEASURE,
UNIT_OF_MEASURE_TYPES.DIMENSION, {
  INCHES: 'inches',
  FEET: 'feet',
  YARDS: 'yards',
  MILLIMETERS: 'millimeters',
  CENTIMETERS: 'centimeters',
  METERS: 'meters' }), _defineProperty(_UNITS_OF_MEASURE,

UNIT_OF_MEASURE_TYPES.WEIGHT, {
  KILOGRAMS: 'kilograms',
  GRAMS: 'grams',
  MILLIGRAMS: 'milligrams',
  POUNDS: 'pounds',
  OUNCES: 'ounces' }), _defineProperty(_UNITS_OF_MEASURE,

UNIT_OF_MEASURE_TYPES.AREA, {
  SQUARE_METERS: 'squareMeters',
  SQUARE_CENTIMETERS: 'squareCentimeters',
  SQUARE_MILLIMETERS: 'squareMillimeters',
  SQUARE_YARDS: 'squareYards',
  SQUARE_FEET: 'squareFeet',
  SQUARE_INCHES: 'squareInches' }), _defineProperty(_UNITS_OF_MEASURE,

UNIT_OF_MEASURE_TYPES.VOLUME, {
  FLUIDOUNCES: 'fluidOunces',
  CUPS: 'cups',
  PINTS: 'pints',
  GALLONS: 'gallons',
  TEASPOONS: 'teaspoons',
  TABLESPOONS: 'tablespoons',
  LITERS: 'liters',
  MILLILITERS: 'milliliters' }), _defineProperty(_UNITS_OF_MEASURE,

UNIT_OF_MEASURE_TYPES.COUNT, {
  PIECES: 'pieces' }), _UNITS_OF_MEASURE);



var SUPPORTED_FUNCTIONS = exports.SUPPORTED_FUNCTIONS = ['clamp', 'abs', 'floor', 'ceil', 'round'];
var SUPPORTED_OPERATORS = exports.SUPPORTED_OPERATORS = ['+', '-', '/', '*', '^', '%'];
var VARIABLE_TOKEN_REGEX = exports.VARIABLE_TOKEN_REGEX = /#{(.*?)}/g;
var VARIABLE_TOKEN_REPLACE_REGEX = exports.VARIABLE_TOKEN_REPLACE_REGEX = /#{|}/g;